import { render, staticRenderFns } from "./BestAuthor.vue?vue&type=template&id=4dda4e36&scoped=true"
import script from "./BestAuthor.vue?vue&type=script&lang=js"
export * from "./BestAuthor.vue?vue&type=script&lang=js"
import style0 from "./BestAuthor.vue?vue&type=style&index=0&id=4dda4e36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dda4e36",
  null
  
)

export default component.exports